import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../../loader/Loader';
import NicheLandingPage from './NicheLandingPage';
import { useLocale } from '../../localization/LocaleContext';

export default function HandymenMain() {
    const { t } = useLocale();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        document.title = t('niche.handymen.metaTitle');
    }, [t]);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) return <Loader />;

    return (
        <Fragment>
            <NicheLandingPage nicheKey="handymen" />
        </Fragment>
    );
}
